import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import { useParams } from "react-router-dom"
import { useGetInstence } from "../../../../hooks/useGetInstence"
import { useState } from "react";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import ResultHandler from "../../../../components/ResultHandler";
import { INFO_FIELDS } from "./CONSTANT";
import { formatCurrency } from "../../../../utils/formatCurrency";
import { ZoomImage } from "../../../../components/zoom-image/ZoomImage";
import { getRoom } from "../../../../api/rooms";
import moment from "moment";

export default function RoomDetails(){
    const {housingId, roomId} = useParams()
    const [room, setRoom] = useState(null)

    const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
        getRoom,
        roomId,
        response => {
            setRoom({
                ...response.data.room,
            })
        }
    )

    const [roomInfoOpen, setRoomInfoOpen] = useState("open")
    const [roomImgOpen, setRoomImgOpen] = useState("open")

    return(
        <div className="page-content company-profile-page">
            <div className="container-fluid">
                <Breadcrumb title="" breadcrumbItem={"Room Details"} />
                <ResultHandler loading={instenceLoading} />

                <Container fluid>
                    {room && <>
                        <Row>
                           <Col md={room.picture ? 6 : 12} lg={room.picture ? 8 : 12}>
                                <Accordion style={{marginBottom: "20px"}} open={roomInfoOpen} toggle={() => setRoomInfoOpen(i => i ? null : "open" )}>
                                    <AccordionItem>
                                        <AccordionHeader targetId="open">
                                            <h5 className="mb-0 text-uppercase">Room Info</h5>
                                        </AccordionHeader>
                                        <AccordionBody style={{backgroundColor: "white"}} accordionId="open">
                                            {INFO_FIELDS.map(f => <Row className="mb-1" key={f.key}>
                                            {f.nested ? f.nested.map(nf => <>
                                                    <Col xs={6}>
                                                        <Label className="mb-0">{nf.label}</Label>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <span style={{fontWeight: "bold"}}>
                                                            {room[f.key][nf.key]}
                                                        </span>
                                                    </Col>
                                                </>) : <>
                                                    <Col xs={6}>
                                                        <Label className="mb-0">{f.label}</Label>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <span style={{fontWeight: "bold"}}>
                                                            {
                                                                f.type == 'date' && room[f.key]
                                                                ? moment(room[f.key]).format('DD MMM YYYY h:mm:ss A')
                                                                : f.type == 'price'
                                                                ? formatCurrency(room[f.key])
                                                                : f.type == 'boolean'
                                                                ? room[f.key] ? "YES" : "NO"
                                                                : room[f.key]
                                                            }
                                                        </span>
                                                    </Col>
                                                </>}
                                            </Row>)}  
                                        </AccordionBody>
                                    </AccordionItem>
                                </Accordion>
                            </Col>
                            
                            {room.picture && (
                                <Col md={6} lg={4}>
                                    <Accordion style={{marginBottom: "20px"}} open={roomImgOpen} toggle={() => setRoomImgOpen(i => i ? null : "open" )}>
                                        <AccordionItem>
                                            <AccordionHeader targetId="open">
                                                <h5 className="mb-0 text-uppercase">Picture</h5>
                                            </AccordionHeader>
                                            <AccordionBody style={{backgroundColor: "white"}} accordionId="open">
                                                <ZoomImage src={room.picture} alt="room image" width="100%"/>
                                            </AccordionBody>
                                        </AccordionItem>
                                    </Accordion>
                                </Col>
                            )}
                        </Row>
                    </>}
                </Container>
            </div>
            
        </div>
    )
}